// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"3be5e981","89":"7d2b1f69","113":"8f23fc0e","139":"35fbdc2e","325":"9a04c2ed","369":"64f76ed7","440":"fd3eec48","618":"e5e066c7","636":"546abb76","648":"8af4d716","652":"d96baff3","843":"35fbdc2e","932":"0c36dfab"}[chunkId] + ".chunk.css";
};